import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../../shared-components/angular-material/mat-animations';
import { StudentService } from '../../../../shared-components/student/student.service';
import { YearService } from '../../../../shared-components/year/year.service';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { CategoryGrid } from '../../../sped-management/sped-management.model';
import { SpedManagementService } from '../../../sped-management/sped-management.service';
import { FormWithinDocumentsService } from '../../form-within-documents.service';
import { GoalData } from '../../formwithin-document-modal';

@Component({
  selector: 'app-pick-goal-maintenance',
  templateUrl: './pick-goal-maintenance.component.html',
  styleUrls: ['./pick-goal-maintenance.component.css'],
  animations: [detailExpand]
})
export class PickGoalMaintenanceComponent implements OnInit {
  dialogTitle = '';
  showSimpleGridData: CategoryGrid[] = [];
  showGoalGridData: CategoryGrid[] = [];
  childData: CategoryGrid[] = [];
  expandRowDataBankId: number;
  tylerMatData = new TylerMatTableDataSource();
  masterTypeId: number;
  goalData = new GoalData();
  yearId: number;
  combineGoalAndObjective: boolean;
  allCheck = false;
  stateCode: string;
  objectiveDescription: string;
  studentXMLDataId: number;
  expandAllRow = false;

  columToInnerGrid = ['CheckBtn', 'DataBankDescription'];
  columnToDisplay = ['More', 'CategoryDescription', 'DataBankDescription', 'Action'];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private spedManagementService: SpedManagementService,
    private matDialogRef: MatDialogRef<PickGoalMaintenanceComponent>,
    private loginService: LoginService,
    private studentDService: StudentService,
    private formWithinDocumentService: FormWithinDocumentsService,
    private yearService: YearService
  ) { }

  ngOnInit(): void {
    this.stateCode = this.loginService.LoginSettings.State;
    this.combineGoalAndObjective = this.loginService.LoginSettings.CombineGoalsAndObjectives;
    this.formWithinDocumentService.goalData.FirstName = this.studentDService.selectedStudent.FirstName;
    this.formWithinDocumentService.goalData.LastName = this.studentDService.selectedStudent.LastName;
    this.formWithinDocumentService.goalData.MasterTypeId = this.masterTypeId;
    this.yearId = this.yearService.defaultYear.Id;
    if (this.combineGoalAndObjective == true) {
      this.getGoalGridData();
    } else {
      this.columnToDisplay.splice(0, 1);
      this.getSimpleGridData();
    }
  }

  getGoalGridData() {
    let masterType: boolean;
    if (this.masterTypeId == 0) {
      masterType = false;
    } else if (this.masterTypeId == 1) {
      masterType = true;
    }
    this.spedManagementService.getObjectiveBankData(0, 0, masterType).subscribe(data => {
      let gridData = [];
      gridData = data.filter(x => x.DataParentId == 0);
      gridData.forEach(detail => {
        detail.child = data.filter(x => x.DataParentId == detail.DataBankId);
        this.childData = data.filter(x => x.DataParentId == detail.DataBankId);
      });
      this.showGoalGridData = gridData;
      this.tylerMatData = new TylerMatTableDataSource(this.showGoalGridData);
      this.tylerMatData.data = this.showGoalGridData;
      if (this.expandRowDataBankId > 0) {
        this.toggleExpanded(this.tylerMatData.data.filter(x => x.DataBankId == this.expandRowDataBankId)[0]);
      }
      setTimeout(() => {
        this.tylerMatData.sort = this.sort;
        this.tylerMatData.paginator = this.paginator;
      }, 0);

    });
  }

  toggleExpanded(row: any) {
    this.tylerMatData.toggleExpanded(row);
  }

  checkExpanded(row: any): boolean {
    return this.tylerMatData.checkExpanded(row);
  }

  rowKeyPress(event: KeyboardEvent, row: any) {
    this.tylerMatData.rowKeyPress(event, row);
  }

  getSimpleGridData() {
    let masterType: boolean;
    if (this.masterTypeId == 0) {
      masterType = false;
    } else if (this.masterTypeId == 1) {
      masterType = true;
    }
    this.spedManagementService.getObjectiveBankData(0, 0, masterType).subscribe(data => {
      this.showSimpleGridData = data;
      this.tylerMatData = new TylerMatTableDataSource(this.showSimpleGridData);
      this.tylerMatData.data = this.showSimpleGridData;
      setTimeout(() => {
        this.tylerMatData.sort = this.sort;
        this.tylerMatData.paginator = this.paginator;
      }, 0);
    });
  }

  onRowSelect(selectedRow: CategoryGrid) {
    const dataBankDescription: string = selectedRow.DataBankDescription;
    this.formWithinDocumentService.goalData.GoalDescription = dataBankDescription.replace('\\Name-F\\', this.formWithinDocumentService.goalData.FirstName).replace('\\Name-L\\', this.formWithinDocumentService.goalData.LastName);
    if (this.objectiveDescription != undefined) {
      this.formWithinDocumentService.goalData.ObjectiveDescription = this.objectiveDescription;
    }
    this.formWithinDocumentService.saveGoalBankData(this.yearId).subscribe(() => {
      this.closeClick(true);
    });
  }

  closeClick(callFromOnRowSelect: boolean = false) {
    if (!callFromOnRowSelect) {
      this.checkOutForm();
    }
    this.matDialogRef.close();
  }

  checkAllClick(child: any) {
    if (this.allCheck == true) {
      child.forEach(objectives => {
        objectives.StatusChecked = true;
        if (this.objectiveDescription == null || this.objectiveDescription == undefined) {
          this.objectiveDescription = ' &#8226; ' + objectives.DataBankDescription + '\n';
        }
        else {
          this.objectiveDescription = this.objectiveDescription + ' &#8226; ' + objectives.DataBankDescription + '\n';
        }
      });
    } else if (this.allCheck == false) {
      child.forEach(selectObjects => {
        selectObjects.StatusChecked = false;
      });
    }
  }

  checkBoxClick(checked: CategoryGrid) {
    if (checked.StatusChecked == true) {
      if (this.objectiveDescription == null || this.objectiveDescription == undefined) {
        this.objectiveDescription = ' &#8226; ' + checked.DataBankDescription + '\n';
      }
      else {
        this.objectiveDescription = this.objectiveDescription + ' &#8226; ' + checked.DataBankDescription + '\n';
      }
    }
  }

  checkOutForm() {
    this.formWithinDocumentService.checkOutForm(this.studentXMLDataId, this.formWithinDocumentService.spedStudentCollectionTemplate.CheckOutByUserId, false).subscribe(() => {
    });
  }

  expandAllRowClick() {
    this.expandAllRow = !this.expandAllRow;
    for (const row of this.tylerMatData.data) {
      row.detailRow = this.expandAllRow;
    }
  }

}